<template>
  <div class="page">
    <div class="page-title">论坛帖子</div>
    <el-form :inline="true" :model="query" class="toolbar">
      <el-form-item>
        <el-select v-model="query.tab" size="small" clearable placeholder="分类">
          <el-option label="租房" value="租房"></el-option>
          <el-option label="求租" value="求租"></el-option>
          <el-option label="买房" value="买房"></el-option>
          <el-option label="卖房" value="卖房"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="query.auditStatus" size="small" clearable placeholder="审核状态">
          <el-option label="待审核" value="待审核"></el-option>
          <el-option label="已通过" value="已通过"></el-option>
          <el-option label="已拒绝" value="已拒绝"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border size="small" v-loading="loading">
      <el-table-column label="图片" width="80">
        <template slot-scope="scope">
          <img
            v-if="coverOf(scope.row)"
            :src="coverOf(scope.row)"
            class="cover"
            referrerpolicy="no-referrer"
            @click="preview(coverOf(scope.row), imagesOf(scope.row))">
          <span v-else class="muted">无图</span>
        </template>
      </el-table-column>
      <el-table-column prop="tab" label="分类" width="80"></el-table-column>
      <el-table-column label="提交用户" width="160">
        <template slot-scope="scope">
          <div class="submit-user">
            <img v-if="scope.row.userUrl" :src="scope.row.userUrl" class="avatar" referrerpolicy="no-referrer">
            <span v-else class="avatar-ph"></span>
            <span>{{ scope.row.userName || '—' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="内容" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="city" label="城市" width="80"></el-table-column>
      <el-table-column prop="community" label="小区" width="110"></el-table-column>
      <el-table-column prop="price" label="价格" width="80"></el-table-column>
      <el-table-column prop="phone" label="电话" width="120"></el-table-column>
      <el-table-column label="审核" width="90">
        <template slot-scope="scope">
          <el-tag size="mini" :type="auditTag(scope.row.auditStatus)">{{ scope.row.auditStatus || '待审核' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="commentCount" label="评论" width="70"></el-table-column>
      <el-table-column prop="createdAt" label="发布时间" width="160" :formatter="fmtTime"></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openDetail(scope.row)">详情/评论</el-button>
          <el-button v-if="scope.row.auditStatus === '待审核'" type="text" size="mini" @click="audit(scope.row, '已通过')">通过</el-button>
          <el-button v-if="scope.row.auditStatus === '待审核'" type="text" size="mini" @click="audit(scope.row, '已拒绝')">拒绝</el-button>
          <el-button v-if="scope.row.auditStatus === '已拒绝'" type="text" size="mini" @click="audit(scope.row, '已通过')">通过</el-button>
          <el-button type="text" size="mini" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :child-msg="pageparm" @callFather="onPage"></Pagination>

    <el-dialog title="帖子详情" :visible.sync="detailVisible" width="720px" top="6vh">
      <div v-if="detail" class="detail">
        <div class="submit-user" style="margin-bottom: 12px;">
          <img v-if="detail.userUrl" :src="detail.userUrl" class="avatar" referrerpolicy="no-referrer">
          <span v-else class="avatar-ph"></span>
          <span>{{ detail.userName || '—' }}</span>
        </div>
        <el-table :data="detailRows" border size="small" class="kv">
          <el-table-column prop="label" label="字段" width="100"></el-table-column>
          <el-table-column prop="value" label="内容"></el-table-column>
        </el-table>
        <div class="c-title">图片（{{ detailImages.length }}）</div>
        <div v-if="detailImages.length" class="gallery">
          <img
            v-for="(url, i) in detailImages"
            :key="i"
            :src="url"
            class="shot"
            referrerpolicy="no-referrer"
            @click="preview(url, detailImages)">
        </div>
        <div v-else class="empty">该帖未上传图片</div>
        <div class="c-title">评论（{{ (detail.comments || []).length }}）</div>
        <el-table :data="detail.comments || []" border size="small" max-height="320">
          <el-table-column prop="userName" label="用户" width="120"></el-table-column>
          <el-table-column prop="replyTo" label="回复" width="120"></el-table-column>
          <el-table-column prop="content" label="内容" min-width="180"></el-table-column>
          <el-table-column prop="createdAt" label="时间" width="160" :formatter="fmtTime"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="removeComment(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!(detail.comments && detail.comments.length)" class="empty">暂无评论</div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="previewVisible" title="查看图片" width="640px" append-to-body>
      <img v-if="previewUrl" :src="previewUrl" class="preview" referrerpolicy="no-referrer">
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '../../components/Pagination'
import { forumPage, forumDetail, auditForum, deleteForum, deleteForumComment, pageBody } from '../../api/spAdmin'
export default {
  components: { Pagination },
  data() {
    return {
      loading: false,
      list: [],
      query: { tab: '', auditStatus: '' },
      pageparm: { currentPage: 1, pageSize: 10, total: 0 },
      detailVisible: false,
      detail: null,
      previewVisible: false,
      previewUrl: ''
    }
  },
  created() { this.load() },
  computed: {
    detailRows() {
      const d = this.detail || {}
      return [
        { label: '分类', value: d.tab },
        { label: '审核', value: d.auditStatus },
        { label: '提交用户', value: d.userName },
        { label: '城市', value: d.city },
        { label: '小区', value: d.community },
        { label: '位置', value: d.location },
        { label: '户型', value: d.layout },
        { label: '价格', value: d.price },
        { label: '电话', value: d.phone },
        { label: '称呼', value: d.contactName },
        { label: '内容', value: d.description }
      ]
    },
    detailImages() {
      return this.imagesOf(this.detail)
    }
  },
  methods: {
    auditTag(status) {
      if (status === '已通过') return 'success'
      if (status === '已拒绝') return 'danger'
      return 'warning'
    },
    fmtTime(row, col, val) {
      if (!val) return ''
      return String(val).replace('T', ' ').slice(0, 19)
    },
    imagesOf(row) {
      if (!row) return []
      if (row.images && row.images.length) return row.images
      const raw = row.imagesJson
      if (!raw) return []
      if (Array.isArray(raw)) return raw
      try {
        const parsed = JSON.parse(raw)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    },
    coverOf(row) {
      const list = this.imagesOf(row)
      return list[0] || ''
    },
    preview(url) {
      if (!url) return
      this.previewUrl = url
      this.previewVisible = true
    },
    search() {
      this.pageparm.currentPage = 1
      this.load()
    },
    onPage(p) {
      this.pageparm.currentPage = p.currentPage
      this.pageparm.pageSize = p.pageSize
      this.load()
    },
    load() {
      this.loading = true
      forumPage({
        page: this.pageparm.currentPage,
        limit: this.pageparm.pageSize,
        tab: this.query.tab,
        auditStatus: this.query.auditStatus
      }).then(res => {
        if (!res || res.status !== 200) {
          this.list = []
          this.pageparm.total = 0
          this.loading = false
          this.$message.error((res && res.message) || '列表加载失败')
          return
        }
        const body = pageBody(res)
        this.list = body.list
        this.pageparm.total = body.total
        this.loading = false
      }, () => { this.loading = false })
    },
    openDetail(row) {
      forumDetail(row.id).then(res => {
        if (res && res.status === 200 && res.data) {
          this.detail = res.data
          this.detailVisible = true
        }
      })
    },
    audit(row, status) {
      const tip = status === '已通过' ? '通过后将在小程序广场展示' : '拒绝后不会在广场展示'
      this.$confirm(tip + '，确认？', '审核', { type: 'warning' }).then(() => {
        return auditForum(row.id, status)
      }).then(res => {
        if (!res || res.status !== 200) {
          this.$message.error((res && res.message) || '操作失败')
          return
        }
        this.$message.success('已更新')
        this.load()
        if (this.detail && this.detail.id === row.id) {
          this.openDetail(row)
        }
      }).catch(() => {})
    },
    remove(row) {
      this.$confirm('确认删除该帖子？', '提示', { type: 'warning' }).then(() => {
        return deleteForum(row.id)
      }).then(() => {
        this.$message.success('已删除')
        this.detailVisible = false
        this.load()
      }).catch(() => {})
    },
    removeComment(row) {
      this.$confirm('确认删除这条评论？删除后小程序不再展示。', '提示', { type: 'warning' }).then(() => {
        return deleteForumComment(row.id)
      }).then(() => {
        this.$message.success('已删除评论')
        if (this.detail && this.detail.id) {
          this.openDetail(this.detail)
        }
        this.load()
      }).catch(() => {})
    }
  }
}
</script>
<style scoped>
.page { padding: 8px 4px 24px; }
.page-title { font-size: 20px; font-weight: 800; color: #1f1633; margin-bottom: 16px; }
.toolbar { background: #fff; padding: 12px 12px 0; border-radius: 12px; margin-bottom: 12px; }
.c-title { margin: 18px 0 10px; font-weight: 600; color: #12263f; }
.empty { color: #999; font-size: 13px; margin-top: 8px; }
.muted { color: #bbb; font-size: 12px; }
.cover { width: 48px; height: 48px; object-fit: cover; border-radius: 6px; cursor: pointer; display: block; }
.submit-user { display: flex; align-items: center; }
.avatar, .avatar-ph { width: 28px; height: 28px; border-radius: 50%; margin-right: 8px; flex-shrink: 0; }
.avatar { object-fit: cover; }
.avatar-ph { background: #e8edf3; display: inline-block; }
.gallery { display: flex; flex-wrap: wrap; gap: 8px; }
.shot { width: 96px; height: 96px; object-fit: cover; border-radius: 8px; cursor: pointer; background: #f2f4f7; }
.preview { display: block; max-width: 100%; max-height: 70vh; margin: 0 auto; }
</style>



// WEBPACK FOOTER //
// src/views/housing/forumList.vue